import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SidebarCategory from './SidebarCategory';
import SidebarLink from './SidebarLink';
import { withTranslation } from 'react-i18next';
import { hasAccess, hasGroupAccess } from "../../Services/SecurityService";
import { useBasicAuth } from '../../../shared/components/auth/withBasicAuth';
import {environment} from '../../../containers/environment';

class SidebarContent extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    changeToDark: PropTypes.func.isRequired,
    changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  }; 

  render() {
    const { t } = this.props;

    let menu = [];
    if(useBasicAuth.checkTokenSidebar()){
      let root = hasGroupAccess("ROOT");
      let administradores = hasGroupAccess("ADMINISTRADORES") || hasGroupAccess("SIGMAGEO");
      let prefeiturasAdministradores = hasGroupAccess("PREFEITURAS_ADMINISTRADORES");
      let prefeituras = hasGroupAccess("PREFEITURAS");
  
      let menuManagement = {};
      let menuManagementItens = [];
      
      let url = useBasicAuth.getUrl();
      if(!url.includes("chat")){
        useBasicAuth.clearIntervals(false, "MENU_CHAT_VIEW_PAGE");
      }
  
      menu.push(<SidebarLink title={t('sidebarContent.cruds.home')} icon="home"  key="homeKey" route="/forms/home" onClick={this.hideSidebar} hasAccess={true} />);
      
      if(root === true){
        let menuSecurity = {};
        if(hasAccess("MENU_SECURITY")){
          let menuSecurityItens = [];
          if(hasAccess("MENU_SECURITY_KEY")){
            menuSecurityItens.push(<SidebarLink title={t('sidebarContent.cruds.securityKeyManagement')} key="securityKeyKey" icon="eye" inside={true} newLink={false} route="/forms/securityKey" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_SECURITY_KEY")} />);
          }
          if(hasAccess("MENU_SECURITY_PROFILE")){
            menuSecurityItens.push(<SidebarLink title={t('sidebarContent.cruds.securityProfileManagement')} key="securityProfileKey" icon="eye" inside={true} newLink={false} route="/forms/securityProfile" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_SECURITY_PROFILE")} />);
          }
          if(hasAccess("MENU_SECURITY_GROUP")){
            menuSecurityItens.push(<SidebarLink title={t('sidebarContent.cruds.securityGroupManagement')} key="securityGroupKey" icon="eye" inside={true} newLink={false} route="/forms/securityGroup" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_SECURITY_GROUP")} />);
          }
          menuSecurity =
            <SidebarCategory title={t('sidebarContent.cruds.security')} key="securityKey" icon="eye" img="" inside={true} isNew={false} hasAccess={hasAccess("MENU_SECURITY")} >
              {menuSecurityItens}
            </SidebarCategory>
  
          menuManagementItens.push(menuSecurity);
        }
      }
  
      if(root || administradores || prefeiturasAdministradores || prefeituras){
        if(hasAccess("MENU_USER_VIEW")){
          menuManagementItens.push(
            <SidebarLink title={t('sidebarContent.cruds.usersManagement')} key="usersmaKey" icon="users" inside={true} newLink={false} route="/forms/users" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_USER_VIEW")} />
          );
        }
      }
  
      if(root || administradores || prefeiturasAdministradores){
        if(hasAccess("MENU_ORGAO_VIEW")){
          menuManagementItens.push(
            <SidebarLink title={t('sidebarContent.cruds.orgaoManagement')} key="orgaomaKey" icon="users" inside={true} newLink={false} route="/forms/organs" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_ORGAO_VIEW")} />
          );
        }
      }
  
      if(root || administradores){
        let menuCity = {};
          if(hasAccess("MENU_CITY")){
            let menuCityItens = [];
            if(hasAccess("MENU_CITY_VIEW")){
              menuCity = <SidebarLink title={t('sidebarContent.cruds.citiesManagement')} key="citiesListKey" icon="earth" inside={true} newLink={false} route="/forms/cities" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_CITY_VIEW")} />
              menuCityItens.push(<SidebarLink title={t('sidebarContent.cruds.list')} key="citiesListKey" icon="earth" inside={true} newLink={false} route="/forms/cities" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_CITY_VIEW")} />);
            }
            if(hasAccess("MENU_CITY_SHP_CITY_AREA")){
              menuCityItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesCidadeAreaManagement')} key="geologiesShapeGeologiasCidadeAreaKey" icon="database" inside={true} newLink={false} route="/forms/cities/geologyShapefileCidadeArea" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_CITY_SHP_CITY_AREA")} />);
            }
            if(menuCityItens.length > 1){
              menuCity = 
                <SidebarCategory title={t('sidebarContent.cruds.citiesManagement')} key="citiesKey" icon="earth" img="" inside={true} isNew={false} hasAccess={hasAccess("MENU_CITY")} >
                  {menuCityItens}
                </SidebarCategory>
            }
            menuManagementItens.push(menuCity);
          }
      }
  
      if(root || administradores){
        let menuState = {};
          if(hasAccess("MENU_STATE")){
            let menuStateItens = [];
            if(hasAccess("MENU_STATE_VIEW")){
              menuState = <SidebarLink title={t('sidebarContent.cruds.statesManagement')} key="statesListKey" icon="earth" inside={true} newLink={false} route="/forms/states" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_STATE_VIEW")} />
              menuStateItens.push(<SidebarLink title={t('sidebarContent.cruds.list')} key="statesListKey" icon="earth" inside={true} newLink={false} route="/forms/states" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_STATE_VIEW")} />);
            }
            if(hasAccess("MENU_STATE_SHP_STATE_AREA")){
              menuStateItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesEstadoAreaManagement')} key="geologiesShapeGeologiasEstadoAreaKey" icon="database" inside={true} newLink={false} route="/forms/states/geologyShapefileEstadoArea" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_STATE_SHP_STATE_AREA")} />);
            }
            if(menuStateItens.length > 1){
              menuState = 
                <SidebarCategory title={t('sidebarContent.cruds.statesManagement')} key="statesKey" icon="earth" img="" inside={true} isNew={false} hasAccess={hasAccess("MENU_STATE")} >
                  {menuStateItens}
                </SidebarCategory>
            }
            menuManagementItens.push(menuState);
          }
      }
  
      if(root || administradores){
        if(hasAccess("MENU_CLIMATE_VIEW")){
          menuManagementItens.push(
            <SidebarLink title={t('sidebarContent.cruds.climatesManagement')} key="climatesKey" icon="sun" inside={true} newLink={false} route="/forms/climates" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_CLIMATE_VIEW")} />
          );
        }
      }
  
      if(root || administradores){
        let menuGeology = {};
        if(hasAccess("MENU_GEOLOGY")){
          let menuGeologyItens = [];
          if(hasAccess("MENU_GEOLOGY_VIEW")){
            menuGeology = <SidebarLink title={t('sidebarContent.cruds.geologiesManagement')} key="geologiesListKey" icon="diamond" inside={true} newLink={false} route="/forms/geologies" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_GEOLOGY_VIEW")} />
            menuGeologyItens.push(<SidebarLink title={t('sidebarContent.cruds.list')} key="geologiesListKey" icon="diamond" inside={true} newLink={false} route="/forms/geologies" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_GEOLOGY_VIEW")} />);
          }
          if(hasAccess("MENU_GEOLOGY_SHP_CITY")){
            menuGeologyItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiasManagement')} key="geologiesShapeGeologiasKey" icon="diamond" inside={true} newLink={false} route="/forms/geologies/geologyShapefile" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_GEOLOGY_SHP_CITY")} />);
          }
          if(hasAccess("MENU_GEOLOGY_SHP_STATE")){
            menuGeologyItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiasEstadoManagement')} key="geologiesShapeGeologiasEstadoKey" icon="diamond" inside={true} newLink={false} route="/forms/geologies/geologyShapefileState" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_GEOLOGY_SHP_STATE")} />)
          }
          if(hasAccess("MENU_GEOLOGY_SHP_COUNTRY")){
            menuGeologyItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiasBrasilManagement')} key="geologiesShapeGeologiasBrasilKey" icon="diamond" inside={true} newLink={false} route="/forms/geologies/geologyShapefileBrazil" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_GEOLOGY_SHP_COUNTRY")} />)
          }
          if(hasAccess("MENU_GEOLOGY_SHP_CAVERNAS")){
            menuGeologyItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesCavernasManagement')} key="geologiesShapeGeologiesCavernasKey" icon="database" inside={true} newLink={false} route="/forms/geologies/geologyShapefileCavernas" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_GEOLOGY_SHP_CAVERNAS")} />);
          }
          if(hasAccess("MENU_GEOLOGY_SHP_PROTECAO_INTEGRAL")){
            menuGeologyItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesProtecaoIntegralManagement')} key="geologiesShapeGeologiesProtecaoIntegralKey" icon="database" inside={true} newLink={false} route="/forms/geologies/geologyShapefileProtecaoIntegral" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_GEOLOGY_SHP_PROTECAO_INTEGRAL")} />);
          }
          if(hasAccess("MENU_GEOLOGY_SHP_QUILOMBOLAS")){
            menuGeologyItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesQuilombolasManagement')} key="geologiesShapeGeologiesQuilombolasKey" icon="database" inside={true} newLink={false} route="/forms/geologies/geologyShapefileQuilombolas" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_GEOLOGY_SHP_QUILOMBOLAS")} />);
          }
          if(hasAccess("MENU_GEOLOGY_SHP_SITIOS_ARQUEOLOGICOS")){
            menuGeologyItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesSitiosArqueologicosManagement')} key="geologiesShapeGeologiesSitiosArqueologicosKey" icon="database" inside={true} newLink={false} route="/forms/geologies/geologyShapefileSitiosArqueologicos" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_GEOLOGY_SHP_SITIOS_ARQUEOLOGICOS")} />);
          }
          if(hasAccess("MENU_GEOLOGY_SHP_TERRAS_INDIGENAS")){
            menuGeologyItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesTerrasIndigenasManagement')} key="geologiesShapeGeologiesTerrasIndigenasKey" icon="database" inside={true} newLink={false} route="/forms/geologies/geologyShapefileTerrasIndigenas" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_GEOLOGY_SHP_TERRAS_INDIGENAS")} />);
          }
          if(hasAccess("MENU_GEOLOGY_SHP_USO_SUSTENTAVEL")){
            menuGeologyItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesUsoSustentavelManagement')} key="geologiesShapeGeologiesUsoSustentavelKey" icon="database" inside={true} newLink={false} route="/forms/geologies/geologyShapefileUsoSustentavel" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_GEOLOGY_SHP_USO_SUSTENTAVEL")} />);
          }
          if(menuGeologyItens.length > 1){
            menuGeology = 
              <SidebarCategory title={t('sidebarContent.cruds.geologiesManagement')} key="geologiesKey" icon="diamond" img="" inside={true} isNew={false} hasAccess={hasAccess("MENU_GEOLOGY")} >
                {menuGeologyItens}
              </SidebarCategory>
          }
          menuManagementItens.push(menuGeology);
        }
      }
  
      if(root || administradores){
        let menuRequirement = {};
        if(hasAccess("MENU_REQUIREMENT")){
          let menuRequirementItens = [];
          if(hasAccess("MENU_REQUIREMENT_VIEW")){
            menuRequirement = <SidebarLink title={t('sidebarContent.cruds.requirementsManagement')} key="requirementsListKey" icon="diamond" inside={true} newLink={false} route="/forms/requirements" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_REQUIREMENT_VIEW")} />
            menuRequirementItens.push(<SidebarLink title={t('sidebarContent.cruds.list')} key="requirementsListKey" icon="diamond" inside={true} newLink={false} route="/forms/requirements" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_REQUIREMENT_VIEW")} />);
          }
          if(hasAccess("MENU_EVENT_VIEW")){
            menuRequirementItens.push(<SidebarLink title={t('sidebarContent.cruds.eventManagement')} key="requirementsEventKey" icon="diamond" inside={true} newLink={false} route="/forms/requirements/events" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_EVENT_VIEW")} />);
          }
          if(hasAccess("MENU_FASE_VIEW")){
            menuRequirementItens.push(<SidebarLink title={t('sidebarContent.cruds.faseManagement')} key="requirementsPhaseKey" icon="diamond" inside={true} newLink={false} route="/forms/requirements/phase" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_FASE_VIEW")} />);
          }
          if(hasAccess("MENU_SUBSTANCE_VIEW")){
            menuRequirementItens.push(<SidebarLink title={t('sidebarContent.cruds.substanceManagement')} key="substanceKey" icon="diamond" inside={true} newLink={false} route="/forms/requirements/substance" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_SUBSTANCE_VIEW")} />);
          }
          if(hasAccess("MENU_SUBSTANCE_USE_VIEW")){
            menuRequirementItens.push(<SidebarLink title={t('sidebarContent.cruds.substanceUseManagement')} key="substanceUseKey" icon="diamond" inside={true} newLink={false} route="/forms/requirements/substanceUse" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_SUBSTANCE_USE_VIEW")} />);
          }
          if(hasAccess("MENU_REQUIREMENT_SHP")){
            menuRequirementItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeRequerimentosManagement')} key="geologiesShapeRequerimentosKey" icon="diamond" inside={true} newLink={false} route="/forms/requirements/geometryShapeRequerimento" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_REQUIREMENT_SHP")} />);
          }
          if(hasAccess("MENU_REQUIREMENT_SYNC_CITY_PROCCESS")){
            menuRequirementItens.push(<SidebarLink title={t('sidebarContent.cruds.syncRequerimentosManagement')} key="syncRequerimentosManagementKey" icon="diamond" inside={true} newLink={false} route="/forms/requirements/sync" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_REQUIREMENT_SYNC_CITY_PROCCESS")} />);
          }
          if(menuRequirementItens.length > 1){
            menuRequirement = 
              <SidebarCategory title={t('sidebarContent.cruds.requirementsManagement')} key="requirementsKey" icon="diamond" img="" inside={true} isNew={false} hasAccess={hasAccess("MENU_REQUIREMENT")} >
                {menuRequirementItens}
              </SidebarCategory>
          }
          menuManagementItens.push(menuRequirement);
        }
      }
  
      if(root || administradores){
        if(hasAccess("MENU_GEOLOGICAL_GROUP_VIEW")){
          menuManagementItens.push(
            <SidebarLink title={t('sidebarContent.cruds.groupsManagement')} key="groupsKey" icon="diamond" inside={true} newLink={false} route="/forms/groups" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_GEOLOGICAL_GROUP_VIEW")} />
          );
        }
      }
  
      if(root || administradores){
        if(hasAccess("MENU_PHYSIOGRAPHIC_ASPECTS_VIEW")){
          menuManagementItens.push(
            <SidebarLink title={t('sidebarContent.cruds.aspectosFisiograficosManagement')} key="aspectosFisiograficosKey" icon="database" inside={true} newLink={false} route="/forms/aspectosFisiograficos" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_PHYSIOGRAPHIC_ASPECTS_VIEW")} />
          );
        }
      }
  
      if(root || administradores){
        if(hasAccess("MENU_LOCATION_ACCESS_VIEW")){
          menuManagementItens.push(
            <SidebarLink title={t('sidebarContent.cruds.localizacaoAcessosManagement')} key="localizacaoAcessosKey" icon="database" inside={true} newLink={false} route="/forms/localizacaoAcessos" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_LOCATION_ACCESS_VIEW")} />
          );
        }
      }
  
      if(root || administradores){
        if(hasAccess("MENU_SOCIOECONOMIC_ENVIRONMENT_VIEW")){
          menuManagementItens.push(
            <SidebarLink title={t('sidebarContent.cruds.meioSocioEconomicosManagement')} key="meioSocioEconomicosKey" icon="database" inside={true} newLink={false} route="/forms/meioSocioEconomicos" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_SOCIOECONOMIC_ENVIRONMENT_VIEW")} />
          );
        }
      }
  
      if(root || administradores){
        let menuUpload = {};
        if(hasAccess("MENU_MEIO_AMBIENTE")){
          let menuUploadItens = [];
          if(hasAccess("MENU_MEIO_AMBIENTE_CLASSE_VIEW")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.meioAmbienteClasseManagement')} key="meioAmbienteClasseKey" icon="database" inside={true} newLink={false} route="/forms/meioAmbienteClasse" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_MEIO_AMBIENTE_CLASSE_VIEW")} />);
          }
          if(hasAccess("MENU_MEIO_AMBIENTE_DIVISAO_VIEW")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.meioAmbienteDivisaoManagement')} key="meioAmbienteDivisaoKey" icon="database" inside={true} newLink={false} route="/forms/meioAmbienteDivisao" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_MEIO_AMBIENTE_DIVISAO_VIEW")} />);
          }
          if(hasAccess("MENU_MEIO_AMBIENTE_GRUPO_VIEW")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.meioAmbienteGrupoManagement')} key="meioAmbienteGrupoKey" icon="database" inside={true} newLink={false} route="/forms/meioAmbienteGrupo" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_MEIO_AMBIENTE_GRUPO_VIEW")} />);
          }
          if(hasAccess("MENU_MEIO_AMBIENTE_AREAS_VIEW")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.meioAmbienteAreasManagement')} key="meioAmbienteAreasKey" icon="database" inside={true} newLink={false} route="/forms/meioAmbienteAreas" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_MEIO_AMBIENTE_AREAS_VIEW")} />);
          }
          if(hasAccess("MENU_MEIO_AMBIENTE_TIPOLOGIA_VIEW")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.meioAmbienteTipologiaManagement')} key="meioAmbienteTipologiaKey" icon="database" inside={true} newLink={false} route="/forms/meioAmbienteTipologia" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_MEIO_AMBIENTE_TIPOLOGIA_VIEW")} />);
          }
          
          menuUpload = 
            <SidebarCategory title={t('sidebarContent.cruds.meioAmbienteManagement')} key="meioAmbienteManagementKey" icon="database" img="" inside={true} isNew={false} hasAccess={hasAccess("MENU_MEIO_AMBIENTE")} >
              {menuUploadItens}
            </SidebarCategory>
          menuManagementItens.push(menuUpload);
        }
      }
    
      if(root || administradores){
        let menuUpload = {};
        if(hasAccess("MENU_UPLOAD")){
          let menuUploadItens = [];
          if(hasAccess("MENU_UPLOAD_SHP_GEOLOGY_CITY")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiasManagement')} key="shapeGeologiasKey" icon="database" inside={true} newLink={false} route="/forms/geologyShapefile" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_UPLOAD_SHP_GEOLOGY_CITY")} />);
          }
          if(hasAccess("MENU_UPLOAD_SHP_GEOLOGY_STATE")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiasEstadoManagement')} key="shapeGeologiasEstadoKey" icon="database" inside={true} newLink={false} route="/forms/geologyShapefileState" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_UPLOAD_SHP_GEOLOGY_STATE")} />);
          }
          if(hasAccess("MENU_UPLOAD_SHP_GEOLOGY_COUNTRY")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiasBrasilManagement')} key="shapeGeologiasBrasilKey" icon="database" inside={true} newLink={false} route="/forms/geologyShapefileBrazil" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_UPLOAD_SHP_GEOLOGY_COUNTRY")} />);
          }
          if(hasAccess("MENU_UPLOAD_SHP_REQUIREMENT")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeRequerimentosManagement')} key="shapeRequerimentosKey" icon="database" inside={true} newLink={false} route="/forms/requirementsShapefile" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_UPLOAD_SHP_REQUIREMENT")} />);
          }
          if(hasAccess("MENU_UPLOAD_SHP_CITY_AREA")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesCidadeAreaManagement')} key="shapeGeologiesCidadeAreaKey" icon="database" inside={true} newLink={false} route="/forms/geologyShapefileCidadeArea" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_UPLOAD_SHP_CITY_AREA")} />);
          }
          if(hasAccess("MENU_UPLOAD_SHP_STATE_AREA")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesEstadoAreaManagement')} key="shapeGeologiesEstadoAreaKey" icon="database" inside={true} newLink={false} route="/forms/geologyShapefileEstadoArea" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_UPLOAD_SHP_STATE_AREA")} />);
          }
          if(hasAccess("MENU_UPLOAD_SHP_CAVERNAS")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesCavernasManagement')} key="shapeGeologiesCavernasKey" icon="database" inside={true} newLink={false} route="/forms/geologyShapefileCavernas" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_UPLOAD_SHP_CAVERNAS")} />);
          }
          if(hasAccess("MENU_UPLOAD_SHP_PROTECAO_INTEGRAL")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesProtecaoIntegralManagement')} key="shapeGeologiesProtecaoIntegralKey" icon="database" inside={true} newLink={false} route="/forms/geologyShapefileProtecaoIntegral" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_UPLOAD_SHP_PROTECAO_INTEGRAL")} />);
          }
          if(hasAccess("MENU_UPLOAD_SHP_QUILOMBOLAS")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesQuilombolasManagement')} key="shapeGeologiesQuilombolasKey" icon="database" inside={true} newLink={false} route="/forms/geologyShapefileQuilombolas" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_UPLOAD_SHP_QUILOMBOLAS")} />);
          }
          if(hasAccess("MENU_UPLOAD_SHP_SITIOS_ARQUEOLOGICOS")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesSitiosArqueologicosManagement')} key="shapeGeologiesSitiosArqueologicosKey" icon="database" inside={true} newLink={false} route="/forms/geologyShapefileSitiosArqueologicos" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_UPLOAD_SHP_SITIOS_ARQUEOLOGICOS")} />);
          }
          if(hasAccess("MENU_UPLOAD_SHP_TERRAS_INDIGENAS")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesTerrasIndigenasManagement')} key="shapeGeologiesTerrasIndigenasKey" icon="database" inside={true} newLink={false} route="/forms/geologyShapefileTerrasIndigenas" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_UPLOAD_SHP_TERRAS_INDIGENAS")} />);
          }
          if(hasAccess("MENU_UPLOAD_SHP_USO_SUSTENTAVEL")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.shapeGeologiesUsoSustentavelManagement')} key="shapeGeologiesUsoSustentavelKey" icon="database" inside={true} newLink={false} route="/forms/geologyShapefileUsoSustentavel" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_UPLOAD_SHP_USO_SUSTENTAVEL")} />);
          }
  
  
          if(hasAccess("MENU_DIARIO_OFICIAL")){
            menuUploadItens.push(<SidebarLink title={t('sidebarContent.cruds.diarioOficialManagement')} key="diarioOficialKey" icon="database" inside={true} newLink={false} route="/forms/diarioOficial" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_DIARIO_OFICIAL")} />);
          }
          menuUpload = 
            <SidebarCategory title={t('sidebarContent.cruds.uploads')} key="uploadsKey" icon="database" img="" inside={true} isNew={false} hasAccess={hasAccess("MENU_UPLOAD")} >
              {menuUploadItens}
            </SidebarCategory>
          menuManagementItens.push(menuUpload);
        }
      }
  
      if(root || administradores){
        menuManagement =
        <SidebarCategory title={t('sidebarContent.cruds.admUser')} key="admmaKey" icon="cog" img="" hasAccess={hasAccess("MENU_ADMINISTRADOR")} >
          {menuManagementItens}
        </SidebarCategory>
        
        menu.push(menuManagement);
      }else{
        if(prefeiturasAdministradores || prefeituras){
          menuManagement =
          <SidebarCategory title={t('sidebarContent.cruds.admUser')} key="admmmKey" icon="cog" img="" hasAccess={hasAccess("MENU_MANAGEMENT")} >
            {menuManagementItens}
          </SidebarCategory>
          
          menu.push(menuManagement);
        }else{
          
        }
      }

      if(hasAccess("MENU_MEIO_AMBIENTE_ENQUADRAMENTO_VIEW")){//MENU_MEIO_AMBIENTE_ENQUADRAMENTO
        menu.push(
          <SidebarLink title={t('sidebarContent.cruds.meioAmbienteEnquadramentoManagement')} key="meioAmbienteEnquadramentoKey" icon="database" inside={false} newLink={false} route="/forms/enquadramento" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_MEIO_AMBIENTE_ENQUADRAMENTO_VIEW")} />
        );
      }

      if(hasAccess("MENU_REQUIREMENT_PROCCESS")){
        menu.push(
          <SidebarLink title={t('sidebarContent.cruds.proccessManagement')} key="proccessKey" icon="database" inside={false} newLink={false} route="/forms/proccess" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_REQUIREMENT_PROCCESS")} />
        );
      }

      
      if(hasAccess("MENU_MY_REQUIREMENT_VIEW")){
        menu.push(
          <SidebarLink title={t('sidebarContent.cruds.myRequirementsManagement')} key="myRequirementsKey" icon="database" inside={false} newLink={false} route="/forms/myrequirements" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_MY_REQUIREMENT_VIEW")} />
        );
      }

      if(hasAccess("MENU_MY_BUFFER_VIEW")){
        menu.push(
          <SidebarLink title={t('sidebarContent.cruds.myBuffersManagement')} key="myBuffersKey" icon="database" inside={false} newLink={false} route="/forms/mybuffers" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_MY_BUFFER_VIEW")} />
        );
      }
  
      if(hasAccess("MENU_MAP")){
        menu.push(
          <SidebarLink title={t('sidebarContent.cruds.map')} key="mapKey" icon="map" route="/forms/map" onClick={this.hideSidebar} hasAccess={hasAccess("MENU_MAP")} />
        );
      }
  
      // menu.push(<SidebarLink title="ArcGis Full" key="mapArcGisFullKey" icon="map" route="/mapArcGisFull" onClick={this.hideSidebar} />);
    }
   
    return (
      <div className="sidebar__content">
        <ul className="sidebar__block">
          {menu}
        </ul>
      </div>
    );
  }
}

export default withTranslation('common')(SidebarContent);